module.exports = __webpack_public_path__ + "img/2015.10.06374f89.png";